import { DefaultState, DropdownItem } from 'store/types';

export const READ_REQUESTS_FILTERS_REQUEST = 'READ_REQUESTS_FILTERS_REQUEST';
export const READ_REQUESTS_FILTERS_SUCCESS = 'READ_REQUESTS_FILTERS_SUCCESS';
export const READ_REQUESTS_FILTERS_FAILURE = 'READ_REQUESTS_FILTERS_FAILURE';

export interface RequestsFiltersData {
  dates: Array<DropdownItem>;
  status: Array<DropdownItem>;
  isFlagged: Array<DropdownItem>;
  guetsTypesSelectList: Array<DropdownItem>;
}

export type RequestsFiltersState = DefaultState & {
  contents?: RequestsFiltersData;
};

interface ReadRequestsFiltersRequest {
  type: typeof READ_REQUESTS_FILTERS_REQUEST;
}

interface ReadRequestsFiltersSuccess {
  type: typeof READ_REQUESTS_FILTERS_SUCCESS;
  contents: RequestsFiltersData;
}

interface ReadRequestsFiltersFailure {
  type: typeof READ_REQUESTS_FILTERS_FAILURE;
}

export type RequestsFiltersActionTypes =
  | ReadRequestsFiltersRequest
  | ReadRequestsFiltersSuccess
  | ReadRequestsFiltersFailure;
